<template>
    <div class="container">
        <div class="left">
            <em>D</em>igital <em>E</em>ducator <em>E</em>ffectiveness <em>P</em>rofile (<em>DEEP</em>) is an assessment tool used to gauge a teacher's understanding and application of online learning. Our personalized assessment is built upon a research-backed framework and aligned to national standards. 
        </div>
        <div class="right">
            <p class="right-header">How personalized are the practices of your teachers?</p>
            
            <p class="right-text">To get started <a href="mailto:Wendy.Oliver@XperienceEducation.com">Wendy.Oliver@XperienceEducation.com</a>  </p>
        </div>
    </div>
</template>

<script>
export default {
    "name": "home-section-3",
    setup() {
        
    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/shared.scss';

.container{
    display:flex; 
    justify-content: center; 
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 100px;


    @media(min-width: $bp-tablet-portrait){
        flex-wrap: nowrap;
        margin-left: 5%; 
        margin-right: 5%; 
    }

    em{
        font-weight: 800;
        color: #662d91;
    }

    .left{
        flex: 100%; 
        text-align: center; 
        font-size: 1.5rem; 
        padding-bottom: 50px;
        border-bottom: 1px solid black;

        @media(min-width: $bp-tablet-portrait){
            flex: 40%;
            border-right: 1px solid gray; 
            padding-right: 20px; 
            text-align: right;
            margin-bottom: 0;
            border-bottom: none;
        }
    }

     .right{
        flex:100%; 
        text-align:center; 
         padding-bottom: 50px;
        
         @media(min-width: $bp-tablet-portrait){
            flex: 45%;
            text-align: left;
            padding-left: 20px; 
            padding-bottom: none;
        }

        .right-header{
            font-size: 2rem; 
            color: grey; 
            font-weight: 600;
            margin-bottom:0;
        }

        .right-text{
            font-size: 1rem; 
            font-weight: 600;

        }

    }
}
</style>